<div class="viewer-right-panel-block">
  <app-mask-opacity></app-mask-opacity>
  <div class="tool-actions">
    <div class="actions-tools">
      <app-tool-list></app-tool-list>
    </div>
    <div class="project-actions">
      <app-project-actions-list></app-project-actions-list>
    </div>
  </div>
</div>
